export default {
    root: {
        class: ['tw-relative tw-inline-flex tw-cursor-pointer tw-select-none tw-align-bottom', 'tw-size-5'],
    },
    box: function (_a) {
        var props = _a.props;
        return ({
            class: [
                'tw-flex tw-justify-center tw-items-center',
                'tw-border-2 tw-size-5 tw-text-gray-700 tw-rounded-full tw-transition tw-duration-200 tw-ease-in-out',
                'dark:tw-bg-zinc-500',
                {
                    'tw-border-zinc-400 tw-bg-white dark:tw-border-zinc-400 dark:tw-text-gray-50': props.value !== props.modelValue && props.value !== void 0,
                    'tw-border-primary-500 tw-bg-primary-500 dark:tw-border-primary-500': props.value == props.modelValue && props.value !== void 0,
                },
                {
                    'hover:tw-border-primary-500 dark:hover:tw-border-primary-400 focus:tw-outline-none focus:tw-outline-offset-0 focus:tw-shadow-[0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:tw-shadow-[inset_0_0_0_0.2rem_rgba(147,197,253,0.5)]': !props.disabled,
                    'tw-cursor-default tw-opacity-60': props.disabled,
                },
            ],
        });
    },
    input: {
        class: [
            'tw-peer tw-w-full tw-h-full tw-absolute tw-top-0 tw-left-0 tw-z-10 tw-p-0 tw-m-0 !tw-opacity-0 tw-rounded-md tw-outline-none tw-border-2 tw-border-gray-200 dark:tw-border-gray-100 tw-appearance-none tw-cursor-pointer',
        ],
    },
    icon: function (_a) {
        var props = _a.props;
        return ({
            class: [
                'tw-transform tw-rounded-full',
                'tw-block tw-w-2.5 tw-h-2.5 tw-bg-white dark:tw-bg-primary-400',
                {
                    'tw-backface-hidden tw-scale-0 tw-invisible': props.value !== props.modelValue,
                    'tw-transform tw-scale-75 tw-visible': props.value == props.modelValue,
                },
                'tw-transition tw-duration-200',
            ],
        });
    },
};
